import React, { Component } from 'react';

// Layouts
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";

// Components
import SponsorsLogo from "../../components/SponsorsLogo";
import ShareBlock from "../../components/ShareBlock";
// import TabPreview from '../../components/previews/Tab_preview'

// Slick Slider - Package
import Cookies from 'universal-cookie';
import service from '../../common/service';
import TabPreview from './Tab_preview';
import HeroHeader from '../../components/HeroHeader';
import TabPreviewOnline from './TabOnline_preview';

//previews
// import SponsorsLogoPreview from '../../components/previews/SponsorsLogo_preview'
// import ShareBlockPreview from '../../components/previews/ShareBlock_preview'

let sub;
const cookies = new Cookies();

class HTFOnlinePreview extends Component {
    constructor() {
        super();
        this.state = {
            films_tab: [
                { title: 'Tickets', isActive: false, index: 0, route: '/' },
                { title: 'How to Watch ', isActive: false, index: 1, route: '/how-to-watch' },
                { title: 'Check Your Tech', isActive: false, index: 2, route: '/check-your-tech' },
                { title: 'Accessibility', isActive: false, index: 3, route: '/accessibility' },
                // { title: 'Health & Wellness', isActive: false, index: 4, route: '/Health-Wellness' },
                { title: 'Safety & belonging', isActive: false, index: 5, route: '/safety-belonging' },
                { title: 'FAQ', isActive: false, index: 6, route: '/faq' },
              ],
            // selectTab: 0,
            homeData: "",
            festInfo: {},
            header_preview: '',
            footer_preview: '',
            sponsorsLogo_preview: '',
            location_preview:null,
            HTFonlinelink:false,
            filmData:[]
        };
        this.apiServe = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    
    getFilmData = () => {
        if(this.props.location.search){
        var paramsData1 =this.props.location.search.replace('?data=','')
        let paramsData = this.apiServe.decrypt(paramsData1)
        var self= this;
        paramsData.then(function (val) {
           self.setState({
               filmData:val
           })
         });
        }
    }
    componentDidMount = () => {
        console.log("home preview")
        this.getFilmData();
        const tab_data_preview = this.state.films_tab.find(e => e.index === parseInt(this.props.location.search.split('?')[1]))
        if (tab_data_preview) {
            this.setState({ location_preview:this.props.location }, 
            () => {
                this.switchTab(tab_data_preview)
            })
        }  

        let particularUser = cookies.get("SundanceNewUser") || cookies.get("particularNewUser");

        if (particularUser && particularUser.token) {
            this.apiServe.sendevent("authentication", {
                token: particularUser.token,
            });
        }
        sub = this.apiServe.getevent().subscribe((response) => {
            switch (response.event) {
                case "authentication":
                    if (response.error) {
                        console.log(response.error);
                        let Zone = localStorage.getItem('TIMEZONE')
                            localStorage.clear();
                        if(Zone) localStorage.setItem('TIMEZONE', Zone)
                    } else {
                        localStorage.setItem("loggedInUser", response.data.user.role);
                        localStorage.setItem("myLoginToken", response.data.token);
                        this.getProfile();
                    }

                    break;
                case "user|getProfile":
                    if (response.error) {
                        console.log(response.error);
                    } else {
                        if (localStorage.getItem("myLoginToken")) {
                            let userInfo = {
                                fname: response.data.fname,
                                lname: response.data.lname,
                                image: response.data.image,
                                showMyLibrary:response.data.showMyLibrary && response.data.showMyLibrary
                            };
                            localStorage.setItem("Header", JSON.stringify(userInfo));
                        }

                        this.setState({ Header: true });
                        this.forceUpdate();
                    }
                    break;
                default:
                    break;
            }


        });

        // Hide video controls on no activity (5 seconds)
        let video = document.querySelector(".sd_video_wpr"),
            timeout;
        if (video) {
            video.addEventListener("mousemove", function () {
                if (document.querySelector('.video-react-control-bar')) {
                    document
                        .querySelector(".video-react-control-bar")
                        .classList.remove("video-react-control-out");

                    clearTimeout(timeout);

                    timeout = setTimeout(function () {
                        document
                            .querySelector(".video-react-control-bar")
                            .classList.add("video-react-control-out");
                    }, 5000);
                }
            });
        }
        
    };

    getProfile = () => {
        this.apiServe.sendevent("user|getProfile", {});
    };
    HTFOnline = () => {
        this.setState({
          HTFonlinelink:false
        },()=>{
          this.props.history.push("/inperson") 
        })
      }
    // Switch Tabs
    switchTab = (tab_data) => {
        var films_tab_copy = [...this.state.films_tab];

        films_tab_copy.forEach((tab) => {
            tab.isActive = false;

            if (tab.title === tab_data.title) {
                tab.isActive = true;
            }
        });
        this.setState({
            films_tab: films_tab_copy,
            selectTab: tab_data.index,
        });
        if (tab_data.index === parseInt(this.state.location_preview?.search.split('?')[1])) {
            this.props.history.push(`/${this.state.location_preview?.pathname}${this.state.location_preview?.search}`)
        } else {
            this.props.history.push(`/online${tab_data.route}`)
        }
        // this.props.history.push(`/online${tab_data.route}`)
    }
    setFestInfo = (info) => {
        this.setState({ festInfo: info })
    }
    
    render() {
        console.log('home_preview',this.state.filmData);
        // State
        const { films_tab, selectTab, festInfo, header_preview, footer_preview,sponsorsLogo_preview,location_preview } = this.state;
        console.log('location_preview',location_preview);
        console.log('selectTab',selectTab);
        return (
            <div className="home">
                {/* Header */}
                {/* <Header hero_header={true} header_preview={header_preview} /> */}
                <Header  history={this.props.history} />
                {/* Content */}
                <HeroHeader newbanner={true} onlinelink={this.HTFOnline} HTFonlinelink={this.state.HTFonlinelink} preData={this.state.filmData}/>
                {/* Tabs Section */}
                <section className="sd_home_section">
                    <div className="sd_home_page_wpr">

                        <div className="sd_home_tab_wpr">
                            <div className="sd_inner_container">
                                <ul>
                                    {
                                        films_tab.map((tab) => {
                                            return (
                                                
                                                <li className={`${tab.index===this.state.filmData.tabIndex || (this.state.filmData.tabData && this.state.filmData.tabData==='howToFestOnline' && tab.isActive) ? 'active' :''}`} key={tab.title}>
                                                    <button className="sd_film_tab_button tab_Button" onClick={this.switchTab.bind(this, tab)}>
                                                        {tab.title}
                                                    </button>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <TabPreviewOnline selectTab={this.state.filmData.tabIndex} festInfo={festInfo} setFestInfo={this.setFestInfo} preData={this.state.filmData} locationtab={ location_preview && parseInt(location_preview.search.split('?')[1])} />
                    </div>
                </section>


                {/* ShareBlock */}
                {/* {footer_preview ? <ShareBlockPreview/>:<ShareBlock/>} */}

                {/* Sponsors Logo */}
                {/* <section className="sd_sponsors_section">
                    {sponsorsLogo_preview ? <SponsorsLogoPreview slider={true} /> : <SponsorsLogo slider={true} />}
                </section> */}

                {/* Footer */}
                <Footer />

            </div>
        )
    }
}

export default HTFOnlinePreview;